/* Liyora — theme scripts. No dependencies. */
(() => {
  'use strict';

  const theme = window.theme || { routes: {}, strings: {} };
  const S = theme.strings;
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message, link) {
    const el = $('#Toast');
    if (!el) return;
    el.innerHTML = '';
    const span = document.createElement('span');
    span.textContent = message;
    el.appendChild(span);
    if (link) {
      const a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.label;
      el.appendChild(a);
    }
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 4000);
  }

  /* ---------- Cart count ---------- */
  function setCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    $$('[data-cart-link]').forEach((el) => el.setAttribute('aria-label', `Sepet, ${count} ürün`));
  }
  async function refreshCartCount() {
    try {
      const res = await fetch(`${theme.routes.cart}.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      setCartCount(cart.item_count);
    } catch (e) { /* count stays as rendered */ }
  }

  /* ---------- Cart drawer ---------- */
  const DRAWER_SECTION = 'cart-drawer';
  const getDrawer = () => document.getElementById('CartDrawer');
  function renderDrawer(html) {
    const drawer = getDrawer();
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('CartDrawerInner');
    const inner = document.getElementById('CartDrawerInner');
    if (!fresh || !inner) return;
    inner.replaceWith(fresh);
    setCartCount(Number(fresh.dataset.count || 0));
  }
  function openDrawer() {
    const drawer = getDrawer();
    if (drawer && !drawer.open && drawer.showModal) {
      drawer.showModal();
      const close = $('[data-close-dialog]', drawer);
      if (close) close.focus();
    }
  }
  async function refreshDrawer() {
    try {
      const res = await fetch(`${theme.routes.root}?sections=${DRAWER_SECTION}`);
      const json = await res.json();
      renderDrawer(json[DRAWER_SECTION]);
    } catch (e) { /* keep server-rendered drawer */ }
  }
  async function changeDrawerLine(line, quantity) {
    const drawer = getDrawer();
    drawer.classList.add('is-loading');
    try {
      const res = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: [DRAWER_SECTION], sections_url: window.location.pathname }),
      });
      const json = await res.json();
      if (!res.ok) {
        const m = $('[data-drawer-message]', drawer);
        if (m) { m.textContent = json.description || json.message || S.error; m.hidden = false; }
      } else {
        renderDrawer(json.sections && json.sections[DRAWER_SECTION]);
      }
    } catch (e) {
      const m = $('[data-drawer-message]', drawer);
      if (m) { m.textContent = S.error; m.hidden = false; }
    }
    drawer.classList.remove('is-loading');
  }
  if (getDrawer()) {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-cart-link]');
      if (link) {
        e.preventDefault();
        openDrawer();
        refreshDrawer();
        return;
      }
      const drawer = getDrawer();
      if (!drawer.contains(e.target)) return;
      const item = e.target.closest('.drawer-item');
      if (!item || drawer.classList.contains('is-loading')) return;
      const line = Number(item.dataset.line);
      const qty = Number(($('.qty__value', item) || {}).textContent) || 0;
      if (e.target.closest('[data-drawer-minus]')) changeDrawerLine(line, Math.max(0, qty - 1));
      else if (e.target.closest('[data-drawer-plus]')) changeDrawerLine(line, qty + 1);
      else if (e.target.closest('[data-drawer-remove]')) changeDrawerLine(line, 0);
    });
  }

  /* ---------- Checkout agreement (cart page and drawer) ---------- */
  document.addEventListener('click', (e) => {
    const checkout = e.target.closest('[data-checkout]');
    if (!checkout) return;
    const form = checkout.closest('form');
    const terms = form && $('[data-cart-terms]', form);
    if (terms && !terms.checked) {
      e.preventDefault();
      terms.closest('.cart__terms').classList.add('is-error');
      terms.focus();
      toast(S.termsRequired);
    }
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-cart-terms]')) e.target.closest('.cart__terms').classList.remove('is-error');
  });

  /* ---------- Announcement ---------- */
  $$('[data-announce]').forEach((bar) => {
    const key = `announce-${bar.dataset.key}`;
    try { if (sessionStorage.getItem(key)) bar.closest('.shopify-section').hidden = true; } catch (e) {}
    const btn = $('[data-announce-close]', bar);
    if (btn) btn.addEventListener('click', () => {
      bar.closest('.shopify-section').hidden = true;
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
    });
  });

  /* ---------- Header: menus, search, dropdowns ---------- */
  const mobileMenu = $('[data-mobile-menu]');
  if (mobileMenu) {
    mobileMenu.addEventListener('toggle', () => {
      document.documentElement.style.overflow = mobileMenu.open ? 'hidden' : '';
    });
    const close = $('[data-mobile-menu-close]', mobileMenu);
    if (close) close.addEventListener('click', () => { mobileMenu.open = false; $('summary', mobileMenu).focus(); });
  }
  const headerSearch = $('[data-header-search]');
  if (headerSearch) {
    headerSearch.addEventListener('toggle', () => {
      if (headerSearch.open) setTimeout(() => { const i = $('input[type="search"]', headerSearch); if (i) i.focus(); }, 30);
    });
  }
  const dropdowns = $$('[data-dropdown]');
  dropdowns.forEach((d) => {
    d.addEventListener('toggle', () => { if (d.open) dropdowns.forEach((o) => { if (o !== d) o.open = false; }); });
  });
  document.addEventListener('click', (e) => {
    dropdowns.forEach((d) => { if (d.open && !d.contains(e.target)) d.open = false; });
    if (headerSearch && headerSearch.open && !headerSearch.contains(e.target)) headerSearch.open = false;
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    dropdowns.forEach((d) => { d.open = false; });
    if (headerSearch) headerSearch.open = false;
    if (mobileMenu && mobileMenu.open) { mobileMenu.open = false; $('summary', mobileMenu).focus(); }
  });

  /* ---------- Dialogs ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-dialog]');
    if (opener) {
      const dlg = document.getElementById(opener.dataset.openDialog);
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    const closer = e.target.closest('[data-close-dialog]');
    if (closer) { closer.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.open) e.target.close(); // backdrop click
  });

  /* ---------- Colour helpers (for the product colour mood) ---------- */
  function parseColor(str) {
    str = (str || '').trim();
    let m = str.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
    if (m) {
      let h = m[1];
      if (h.length === 3) h = h.split('').map((c) => c + c).join('');
      return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
    }
    m = str.match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/i);
    if (m) return [m[1], m[2], m[3]].map(Number);
    return null;
  }
  const toHex = (rgb) => '#' + rgb.map((v) => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, '0')).join('');
  const mix = (a, b, t) => a.map((v, i) => v * t + b[i] * (1 - t));
  function luminance(rgb) {
    const [r, g, b] = rgb.map((v) => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }
  const MOOD_TOKENS = ['--c-bg', '--c-soft', '--c-mid', '--c-accent', '--c-accent-fg', '--c-text'];
  function basePalette() {
    const cs = getComputedStyle(document.documentElement);
    const get = (k) => parseColor(cs.getPropertyValue(k));
    return { bg: get('--c-bg'), soft: get('--c-soft'), mid: get('--c-mid'), accent: get('--c-accent'), text: get('--c-text') };
  }
  function applyMood(zone, hex) {
    const mode = zone.dataset.mood;
    const vc = parseColor(hex);
    if (!mode || mode === 'off' || !vc) {
      MOOD_TOKENS.forEach((k) => zone.style.removeProperty(k));
      return;
    }
    const p = basePalette();
    if (!p.bg || !p.text) return;
    const WHITE = [255, 255, 255];
    const BLACK = [0, 0, 0];
    let t;
    if (mode === 'soft') {
      t = [mix(vc, p.bg, 0.13), mix(vc, p.bg, 0.3), p.mid, p.accent, p.bg, p.text];
    } else if (luminance(vc) < 0.12) {
      // dark colours: the zone turns dark, text and buttons turn light
      const bg = mix(vc, BLACK, 0.82);
      const fg = mix(WHITE, vc, 0.9);
      t = [bg, mix(fg, bg, 0.16), mix(fg, bg, 0.4), p.soft, mix(vc, BLACK, 0.5), fg];
    } else {
      const bg = mix(vc, p.bg, 0.38);
      t = [bg, mix(vc, p.bg, 0.7), mix(vc, p.text, 0.6), p.accent, mix(p.bg, WHITE, 0.5), p.text];
    }
    MOOD_TOKENS.forEach((k, i) => zone.style.setProperty(k, toHex(t[i])));
  }

  /* ---------- Product page ---------- */
  function initProduct(zone) {
    const jsonEl = $('[data-product-json]', zone);
    const form = $('form.product-form', zone);
    if (!jsonEl || !form) return;
    const data = JSON.parse(jsonEl.textContent);
    const variants = data.variants;
    const fieldsets = $$('[data-option]', form);
    const idInput = $('[data-variant-input]', form);
    const addBtn = $('[data-add-button]', form);
    const msg = $('[data-form-message]', form);
    const priceWrap = $('[data-price-wrap]', zone);
    const stockEl = $('[data-stock]', form);
    const qtyInput = $('[data-qty-input]', form);
    let current = variants.find((v) => String(v.id) === idInput.value) || variants[0];

    /* Gallery */
    const track = $('[data-gallery-track]', zone);
    const slides = track ? $$('.gallery__slide', track) : [];
    const thumbs = $$('[data-thumb]', zone);
    const dots = $$('.gallery__dots span', zone);
    let index = 0;
    function goTo(i, smooth = true) {
      if (!track || !slides.length) return;
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: smooth && !reducedMotion ? 'smooth' : 'auto' });
      markActive();
    }
    function markActive() {
      thumbs.forEach((t, j) => t.setAttribute('aria-current', j === index ? 'true' : 'false'));
      dots.forEach((d, j) => d.classList.toggle('is-active', j === index));
    }
    if (track) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== index && i >= 0 && i < slides.length) { index = i; markActive(); }
        });
      }, { passive: true });
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      });
    }
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
    const prev = $('[data-gallery-prev]', zone);
    const next = $('[data-gallery-next]', zone);
    if (prev) prev.addEventListener('click', () => goTo(index - 1));
    if (next) next.addEventListener('click', () => goTo(index + 1));
    function showMedia(mediaId) {
      if (!mediaId) return;
      const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i >= 0 && i !== index) goTo(i);
    }

    /* Zoom */
    const zoomDlg = $('#ZoomDialog', zone);
    const zoomImg = zoomDlg && $('[data-zoom-img]', zoomDlg);
    $$('[data-zoom]', zone).forEach((btn) => btn.addEventListener('click', () => {
      if (!zoomDlg || !zoomDlg.showModal) return;
      zoomImg.src = btn.dataset.zoom;
      zoomImg.alt = btn.dataset.zoomAlt || '';
      zoomDlg.showModal();
    }));
    if (zoomImg) zoomImg.addEventListener('click', () => zoomDlg.close());

    /* Variant selection */
    const selected = () => fieldsets.map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });
    const matches = (v, sel, skip) => sel.every((val, i) => i === skip || val === null || v.options[i] === val);

    function updateAvailability(sel) {
      const last = fieldsets.length - 1;
      fieldsets.forEach((fs, i) => {
        $$('input', fs).forEach((input) => {
          const candidate = variants.filter((v) => v.options[i] === input.value && matches(v, sel, i));
          const available = candidate.some((v) => v.available);
          input.classList.toggle('is-unavailable', !available);
          // The last option (usually size) cannot be picked when sold out for the current selection.
          input.disabled = i === last && fieldsets.length > 0 && !available && !input.checked;
        });
      });
    }

    function colorHex() {
      const input = $('input[data-color]:checked', form);
      return input ? input.dataset.color : null;
    }

    function render(sel) {
      const complete = sel.every((v) => v !== null);
      const variant = complete ? variants.find((v) => v.options.every((o, i) => o === sel[i])) : null;
      fieldsets.forEach((fs, i) => { const out = $('[data-option-value]', fs); if (out) out.textContent = sel[i] || ''; });
      updateAvailability(sel);
      msg.hidden = true;

      if (!variant) {
        requestAnimationFrame(syncSticky);
        // Still show the photo of the chosen colour while the size is not picked yet.
        const partial = variants.find((v) => v.media_id && matches(v, sel, -1));
        if (partial) showMedia(partial.media_id);
        current = null;
        addBtn.disabled = !complete ? false : true;
        addBtn.textContent = complete ? S.unavailable : S.addToCart;
        stockEl.textContent = '';
        return;
      }
      current = variant;
      idInput.value = variant.id;
      if (priceWrap) priceWrap.innerHTML = variant.price_html;
      stockEl.textContent = variant.stock_text || '';
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? S.addToCart : S.soldOut;
      if (qtyInput) {
        if (variant.max !== null) qtyInput.max = Math.max(1, variant.max); else qtyInput.removeAttribute('max');
        if (variant.max !== null && Number(qtyInput.value) > variant.max) qtyInput.value = Math.max(1, variant.max);
      }
      showMedia(variant.media_id);
      syncSticky();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', (e) => {
      if (!e.target.classList.contains('option__input')) return;
      const changedSet = e.target.closest('[data-option]');
      const sel = selected();
      // If another option became impossible with this choice, clear the last option so the customer picks again.
      const changedIdx = fieldsets.indexOf(changedSet);
      const last = fieldsets.length - 1;
      if (changedIdx !== last && sel[last] !== null) {
        const ok = variants.some((v) => v.available && v.options.every((o, i) => o === sel[i]));
        if (!ok) {
          const lastChecked = $('input:checked', fieldsets[last]);
          if (lastChecked) lastChecked.checked = false;
          sel[last] = null;
        }
      }
      render(sel);
      if (e.target.dataset.color !== undefined || changedSet.classList.contains('option--color')) {
        applyMood(zone, colorHex());
      }
    });

    /* Quantity */
    const qtyMinus = $('[data-qty-minus]', form);
    const qtyPlus = $('[data-qty-plus]', form);
    const clampQty = (n) => {
      const max = qtyInput.max ? Number(qtyInput.max) : 99;
      return Math.max(1, Math.min(max, n || 1));
    };
    if (qtyMinus) qtyMinus.addEventListener('click', () => { qtyInput.value = clampQty(Number(qtyInput.value) - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', () => { qtyInput.value = clampQty(Number(qtyInput.value) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', () => { qtyInput.value = clampQty(Number(qtyInput.value)); });

    /* Add to cart (Shopify AJAX cart) */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!current) {
        msg.textContent = S.selectOptions;
        msg.hidden = false;
        return;
      }
      if (!current.available) return;
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      msg.hidden = true;
      try {
        const body = new FormData();
        body.append('id', current.id);
        body.append('quantity', qtyInput ? clampQty(Number(qtyInput.value)) : 1);
        const useDrawer = !!getDrawer();
        if (useDrawer) {
          body.append('sections', DRAWER_SECTION);
          body.append('sections_url', window.location.pathname);
        }
        const res = await fetch(`${theme.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const json = await res.json();
        if (!res.ok) {
          msg.textContent = json.description || json.message || S.error;
          msg.hidden = false;
        } else if (useDrawer && json.sections && json.sections[DRAWER_SECTION]) {
          renderDrawer(json.sections[DRAWER_SECTION]);
          openDrawer();
        } else {
          const opts = current.options.filter((o) => o !== 'Default Title').join(' · ');
          toast(`${S.added}${opts ? ': ' + opts : ''}`, { href: theme.routes.cart, label: S.goToCart });
          refreshCartCount();
        }
      } catch (err) {
        msg.textContent = S.error;
        msg.hidden = false;
      } finally {
        addBtn.disabled = !current || !current.available;
        addBtn.removeAttribute('aria-busy');
        syncSticky();
      }
    });

    /* Sticky add-to-cart bar (mobile) */
    const sticky = $('[data-sticky-buy]', zone);
    const stickyBtn = sticky && $('[data-sticky-add]', sticky);
    const stickyPrice = sticky && $('[data-sticky-price]', sticky);
    function syncSticky() {
      if (!stickyBtn) return;
      stickyBtn.textContent = addBtn.textContent;
      stickyBtn.disabled = addBtn.disabled;
      if (current && stickyPrice && current.price_small_html) stickyPrice.innerHTML = current.price_small_html;
    }
    if (sticky) {
      const buy = $('.buy', form);
      let shown = null;
      let ticking = false;
      // Position check on scroll: works for fast flings and jumps, where an observer can miss the crossing.
      const update = () => {
        ticking = false;
        const show = buy.getBoundingClientRect().bottom < 0;
        if (show === shown) return;
        shown = show;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyBtn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('has-sticky-buy', show);
      };
      window.addEventListener('scroll', () => {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      update();
      stickyBtn.addEventListener('click', () => {
        if (!current) {
          const missing = fieldsets.find((fs) => !$('input:checked', fs)) || fieldsets[0];
          (missing || form).scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
          msg.textContent = S.selectOptions;
          msg.hidden = false;
          return;
        }
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }

    /* Complete the look (Search & Discovery complementary products) */
    $$('[data-complementary]', zone).forEach(async (box) => {
      try {
        const res = await fetch(box.dataset.url);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const list = doc.querySelector('[data-complementary-result] .pairs__list');
        if (!list || !list.children.length) return;
        const h = document.createElement('h2');
        h.className = 'pairs__title';
        h.textContent = box.dataset.title;
        box.replaceChildren(h, list);
        box.hidden = false;
      } catch (e) { /* stays hidden */ }
    });

    /* Initial state */
    const initialSel = selected();
    updateAvailability(initialSel);
    applyMood(zone, colorHex());
    if (current && current.media_id) {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(current.media_id));
      if (i > 0) { index = i; requestAnimationFrame(() => goTo(i, false)); }
    }
  }
  $$('[data-product-zone]').forEach(initProduct);

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach((el) => {
    const load = async () => {
      try {
        const res = await fetch(el.dataset.url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      } catch (e) { /* section stays empty */ }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) { io.disconnect(); load(); }
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else load();
  });

  /* ---------- Collection filters ---------- */
  $$('[data-filter-form]').forEach((form) => {
    const panel = $('[data-filter-panel]', form);
    const openBtn = $('[data-filter-open]', form);
    const closeBtn = $('[data-filter-close]', form);
    const desktop = window.matchMedia('(min-width: 990px)');
    const setOpen = (open) => {
      if (!panel) return;
      panel.classList.toggle('is-open', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { const f = $('summary, input, button', panel); if (f) f.focus(); }
    };
    if (openBtn) openBtn.addEventListener('click', () => setOpen(true));
    if (closeBtn) closeBtn.addEventListener('click', () => { setOpen(false); openBtn && openBtn.focus(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) setOpen(false); });

    // Drop empty fields so URLs stay clean.
    form.addEventListener('submit', () => {
      $$('input, select', form).forEach((el) => { if (!el.value) el.disabled = true; });
    });
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-autosubmit]')) return;
      // On mobile the drawer stays open until "Sonuçları göster" is pressed, except for sorting.
      if (desktop.matches || e.target.name === 'sort_by') form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  /* ---------- Cart page ---------- */
  function initCart() {
    const root = $('#MainCart');
    if (!root) return;
    const sectionId = root.dataset.sectionId;
    let busy = false;

    async function change(line, quantity) {
      if (busy) return;
      busy = true;
      const form = $('#CartForm', root);
      if (form) form.classList.add('is-loading');
      try {
        const res = await fetch(`${theme.routes.cartChange}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: [sectionId], sections_url: window.location.pathname }),
        });
        const json = await res.json();
        if (!res.ok) {
          const m = $('[data-cart-message]', root);
          if (m) { m.textContent = json.description || json.message || S.error; m.hidden = false; }
          if (form) form.classList.remove('is-loading');
          busy = false;
          return;
        }
        const html = json.sections && json.sections[sectionId];
        if (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('#MainCart');
          if (fresh) root.innerHTML = fresh.innerHTML;
        } else {
          window.location.reload();
          return;
        }
        setCartCount(json.item_count);
      } catch (e) {
        window.location.reload();
        return;
      }
      busy = false;
    }

    root.addEventListener('click', (e) => {
      const item = e.target.closest('.cart-item');
      if (!item) return;
      const line = Number(item.dataset.line);
      const input = $('[data-cart-qty]', item);
      if (e.target.closest('[data-cart-minus]')) {
        change(line, Math.max(0, Number(input.value) - 1));
      } else if (e.target.closest('[data-cart-plus]')) {
        const max = input.max ? Number(input.max) : Infinity;
        const n = Number(input.value) + 1;
        if (n > max) {
          const m = $('[data-cart-message]', root);
          if (m) { m.textContent = `Bu üründen en fazla ${max} adet ekleyebilirsiniz.`; m.hidden = false; }
          return;
        }
        change(line, n);
      } else if (e.target.closest('[data-cart-remove]')) {
        e.preventDefault();
        change(line, 0);
      }
    });
    root.addEventListener('change', (e) => {
      if (e.target.matches('[data-cart-qty]')) {
        const item = e.target.closest('.cart-item');
        change(Number(item.dataset.line), Math.max(0, Number(e.target.value) || 0));
      }
    });
  }
  initCart();

  /* Keep the count right when a page is restored from the back/forward cache. */
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCartCount(); });
})();
